import { AxiosResponse } from 'axios';
import { ApiService } from 'services';
import {
    AllianceDataFormType,
    CooperationFormData,
    SubscriptionForm,
} from 'types';

export class FormsApi extends ApiService {
    public sendCooperationFormData(
        data: CooperationFormData
    ): Promise<AxiosResponse> {
        return this.request({
            method: 'POST',
            url: '/CooperationForm/Add',
            data,
            withCredentials: true,
        });
    }

    public sendSubscriptionFormData(
        data: SubscriptionForm
    ): Promise<AxiosResponse> {
        return this.request({
            method: 'POST',
            url: '/SubscriptionForm/Add',
            data,
            withCredentials: true,
        });
    }
    public sendAllianceFormData(
        data: AllianceDataFormType
    ): Promise<AxiosResponse> {
        return this.request({
            method: 'POST',
            url: '/AllianceForm/Add',
            data,
            withCredentials: true,
        });
    }
}
